import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Gamepad2, History } from "lucide-react";

const TABS = [
  { path: "/game-list", label: "Marketplace", icon: Gamepad2 },
  { path: "/transaction-history", label: "Transactions", icon: History },
];

// Mobile-only bottom tab bar, mirrors the desktop Navbar's nav links.
const BottomNav = ({ abc, xyz }) => {
  const location = useLocation();

  const createUrl = (path) => {
    const params = new URLSearchParams();
    if (abc) params.set("abc", abc);
    if (xyz) params.set("xyz", xyz);
    return `${path}?${params.toString()}`;
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-black border-t border-gray-900 flex"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      {TABS.map(({ path, label, icon: Icon }) => (
        <Link
          key={path}
          to={createUrl(path)}
          className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 text-xs font-medium transition ${
            isActive(path) ? "text-green-400" : "text-gray-400 hover:text-white"
          }`}
        >
          <Icon className="h-5 w-5" />
          <span>{label}</span>
        </Link>
      ))}
    </nav>
  );
};

export default BottomNav;
